import {gql} from "@apollo/client";

const TAGS = gql`
    query Tags($filterEnabled: Boolean, $hasListings: Boolean, $all: Boolean, $ids: [ID], $categories: [ID]) {
        tags(filterEnabled: $filterEnabled, hasListings: $hasListings, all: $all, ids: $ids, categories: $categories) {
            ID
            Identifier
            Title
        }
    }
`

export default TAGS;
